"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _variables = require("../common/variables.js");

var _utils = require("../common/utils.js");

var _BackgroundColorContext = _interopRequireDefault(require("../BackgroundColorContext"));

var _NumberInputContext = _interopRequireDefault(require("../number-input/NumberInputContext"));

var _Suggestions = _interopRequireDefault(require("./Suggestions"));

var Popover = _interopRequireWildcard(require("@radix-ui/react-popover"));

var _Icons = _interopRequireDefault(require("./Icons"));

var _uuid = require("uuid");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var sizes = {
  small: "240px",
  medium: "360px",
  large: "480px",
  fillParent: "100%"
};

var AutosuggestWrapper = function AutosuggestWrapper(_ref) {
  var condition = _ref.condition,
      wrapper = _ref.wrapper,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, condition ? wrapper(children) : children);
};

var calculateWidth = function calculateWidth(margin, size) {
  return size === "fillParent" ? "calc(".concat(sizes[size], " - ").concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")") : sizes[size];
};

var makeCancelable = function makeCancelable(promise) {
  var hasCanceled_ = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (promiseError) {
      return hasCanceled_ ? reject({
        isCanceled: true
      }) : reject(promiseError);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled_ = true;
    }
  };
};

var hasSuggestions = function hasSuggestions(suggestions) {
  return typeof suggestions === "function" || (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0;
};

var isNotOptional = function isNotOptional(value, optional) {
  return value === "" && !optional;
};

var isLengthIncorrect = function isLengthIncorrect(value, minLength, maxLength) {
  return value && minLength && maxLength && (value.length < minLength || value.length > maxLength);
};

var isNumberIncorrect = function isNumberIncorrect(value, minNumber, maxNumber) {
  return minNumber && parseInt(value) < minNumber || maxNumber && parseInt(value) > maxNumber;
};

var patternMissmatch = function patternMissmatch(pattern, value) {
  return pattern && !new RegExp(pattern).test(value);
};

var DxcTextInput = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var label = _ref2.label,
      _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? "" : _ref2$name,
      _ref2$defaultValue = _ref2.defaultValue,
      defaultValue = _ref2$defaultValue === void 0 ? "" : _ref2$defaultValue,
      value = _ref2.value,
      helperText = _ref2.helperText,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? "" : _ref2$placeholder,
      action = _ref2.action,
      _ref2$clearable = _ref2.clearable,
      clearable = _ref2$clearable === void 0 ? false : _ref2$clearable,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$optional = _ref2.optional,
      optional = _ref2$optional === void 0 ? false : _ref2$optional,
      _ref2$prefix = _ref2.prefix,
      prefix = _ref2$prefix === void 0 ? "" : _ref2$prefix,
      _ref2$suffix = _ref2.suffix,
      suffix = _ref2$suffix === void 0 ? "" : _ref2$suffix,
      onChange = _ref2.onChange,
      onBlur = _ref2.onBlur,
      error = _ref2.error,
      suggestions = _ref2.suggestions,
      pattern = _ref2.pattern,
      minLength = _ref2.minLength,
      maxLength = _ref2.maxLength,
      _ref2$autocomplete = _ref2.autocomplete,
      autocomplete = _ref2$autocomplete === void 0 ? "off" : _ref2$autocomplete,
      margin = _ref2.margin,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? "medium" : _ref2$size,
      _ref2$tabIndex = _ref2.tabIndex,
      tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex;

  var _useState = (0, _react.useState)("input-".concat((0, _uuid.v4)())),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
      inputId = _useState2[0];

  var autosuggestId = "suggestions-".concat(inputId);
  var errorId = "error-".concat(inputId);

  var _useState3 = (0, _react.useState)(defaultValue),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      innerValue = _useState4[0],
      setInnerValue = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      isOpen = _useState6[0],
      changeIsOpen = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      isSearching = _useState8[0],
      changeIsSearching = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      isAutosuggestError = _useState10[0],
      changeIsAutosuggestError = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      filteredSuggestions = _useState12[0],
      changeFilteredSuggestions = _useState12[1];

  var _useState13 = (0, _react.useState)(-1),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      visualFocusIndex = _useState14[0],
      changeVisualFocusIndex = _useState14[1];

  var inputRef = (0, _react.useRef)(null);
  var actionRef = (0, _react.useRef)(null);
  var colorsTheme = (0, _useTheme["default"])();
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  var backgroundType = (0, _react.useContext)(_BackgroundColorContext["default"]);
  var numberInputContext = (0, _react.useContext)(_NumberInputContext["default"]);

  var getNumberErrorMessage = function getNumberErrorMessage(value) {
    if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.minNumber && parseInt(value) < (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.minNumber)) return translatedLabels.numberInput.valueGreaterThanOrEqualToErrorMessage(numberInputContext.minNumber);else if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.maxNumber && parseInt(value) > (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.maxNumber)) return translatedLabels.numberInput.valueLessThanOrEqualToErrorMessage(numberInputContext.maxNumber);
  };

  var getTextInputWidth = (0, _react.useCallback)(function () {
    var _inputRef$current, _inputRef$current$par;

    var rect = inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : (_inputRef$current$par = _inputRef$current.parentElement) === null || _inputRef$current$par === void 0 ? void 0 : _inputRef$current$par.getBoundingClientRect();
    return rect === null || rect === void 0 ? void 0 : rect.width;
  }, []);

  var openSuggestions = function openSuggestions() {
    hasSuggestions(suggestions) && changeIsOpen(true);
  };

  var closeSuggestions = function closeSuggestions() {
    if (hasSuggestions(suggestions)) {
      changeIsOpen(false);
      changeVisualFocusIndex(-1);
    }
  };

  var changeValue = function changeValue(newValue) {
    value !== null && value !== void 0 ? value : setInnerValue(newValue);
    var changedValue = typeof newValue === "number" ? newValue.toString() : newValue;
    if (isNotOptional(newValue, optional)) onChange === null || onChange === void 0 ? void 0 : onChange({
      value: changedValue,
      error: translatedLabels.formFields.requiredValueErrorMessage
    });else if (isLengthIncorrect(newValue, minLength, maxLength)) onChange === null || onChange === void 0 ? void 0 : onChange({
      value: changedValue,
      error: translatedLabels.formFields.lengthErrorMessage(minLength, maxLength)
    });else if (patternMissmatch(pattern, newValue)) onChange === null || onChange === void 0 ? void 0 : onChange({
      value: changedValue,
      error: translatedLabels.formFields.formatRequestedErrorMessage
    });else if (isNumberIncorrect(newValue, numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.minNumber, numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.maxNumber)) onChange === null || onChange === void 0 ? void 0 : onChange({
      value: changedValue,
      error: getNumberErrorMessage(newValue)
    });else onChange === null || onChange === void 0 ? void 0 : onChange({
      value: changedValue
    });
  };

  var handleInputContainerOnClick = function handleInputContainerOnClick() {
    document.activeElement !== actionRef.current && inputRef.current.focus();
  };

  var handleInputContainerOnMouseDown = function handleInputContainerOnMouseDown(event) {
    // Avoid input to lose the focus when the container is pressed
    document.activeElement === inputRef.current && event.preventDefault();
  };

  var handleInputOnChange = function handleInputOnChange(event) {
    openSuggestions();
    changeValue(event.target.value);
  };

  var handleInputOnBlur = function handleInputOnBlur(event) {
    closeSuggestions();
    if (isNotOptional(event.target.value, optional)) onBlur === null || onBlur === void 0 ? void 0 : onBlur({
      value: event.target.value,
      error: translatedLabels.formFields.requiredValueErrorMessage
    });else if (isLengthIncorrect(event.target.value, minLength, maxLength)) onBlur === null || onBlur === void 0 ? void 0 : onBlur({
      value: event.target.value,
      error: translatedLabels.formFields.lengthErrorMessage(minLength, maxLength)
    });else if (patternMissmatch(pattern, event.target.value)) onBlur === null || onBlur === void 0 ? void 0 : onBlur({
      value: event.target.value,
      error: translatedLabels.formFields.formatRequestedErrorMessage
    });else if (isNumberIncorrect(event.target.value, numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.minNumber, numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.maxNumber)) onBlur === null || onBlur === void 0 ? void 0 : onBlur({
      value: event.target.value,
      error: getNumberErrorMessage(event.target.value)
    });else onBlur === null || onBlur === void 0 ? void 0 : onBlur({
      value: event.target.value
    });
  };

  var handleInputOnKeyDown = function handleInputOnKeyDown(event) {
    switch (event.key) {
      case "Down":
      case "ArrowDown":
        event.preventDefault();

        if ((numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.typeNumber) === "number") {
          decrementNumber();
        } else {
          openSuggestions();

          if (!isAutosuggestError && !isSearching && filteredSuggestions.length > 0) {
            changeVisualFocusIndex(function (visualFocusedSuggIndex) {
              if (visualFocusedSuggIndex < filteredSuggestions.length - 1) return visualFocusedSuggIndex + 1;else if (visualFocusedSuggIndex === filteredSuggestions.length - 1) return 0;
            });
          }
        }

        break;

      case "Up":
      case "ArrowUp":
        event.preventDefault();

        if ((numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.typeNumber) === "number") {
          incrementNumber();
        } else {
          openSuggestions();

          if (!isAutosuggestError && !isSearching && filteredSuggestions.length > 0) {
            changeVisualFocusIndex(function (visualFocusedSuggIndex) {
              if (visualFocusedSuggIndex === 0 || visualFocusedSuggIndex === -1) return filteredSuggestions.length > 0 ? filteredSuggestions.length - 1 : suggestions.length - 1;else return visualFocusedSuggIndex - 1;
            });
          }
        }

        break;

      case "Esc":
      case "Escape":
        event.preventDefault();

        if (hasSuggestions(suggestions)) {
          changeValue("");
          isOpen && closeSuggestions();
        }

        break;

      case "Enter":
        if (hasSuggestions(suggestions) && !isSearching) {
          var validFocusedSuggestion = filteredSuggestions.length > 0 && visualFocusIndex >= 0 && visualFocusIndex < filteredSuggestions.length;
          validFocusedSuggestion && changeValue(filteredSuggestions[visualFocusIndex]);
          isOpen && closeSuggestions();
        }

        break;
    }
  };

  var handleClearActionOnClick = function handleClearActionOnClick() {
    changeValue("");
    inputRef.current.focus();
    suggestions && closeSuggestions();
  };

  var handleDecrementActionOnClick = function handleDecrementActionOnClick() {
    decrementNumber();
    inputRef.current.focus();
  };

  var handleIncrementActionOnClick = function handleIncrementActionOnClick() {
    incrementNumber();
    inputRef.current.focus();
  };

  var setNumberProps = function setNumberProps(type, min, max, step) {
    var _inputRef$current2, _inputRef$current3, _inputRef$current4, _inputRef$current5;

    type && (inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.setAttribute("type", type));
    min && (inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.setAttribute("min", min));
    max && (inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.setAttribute("max", max));
    step && (inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.setAttribute("step", step));
  };

  var decrementNumber = function decrementNumber() {
    var numberValue = value !== null && value !== void 0 ? value : innerValue;

    if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.minNumber && parseInt(numberValue) < (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.minNumber)) {
      changeValue(parseInt(numberValue));
    } else if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.maxNumber && parseInt(numberValue) > (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.maxNumber)) {
      changeValue(numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.maxNumber);
    } else if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.minNumber && (parseInt(numberValue) === (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.minNumber) || numberValue === "" || numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.stepNumber && parseInt(numberValue) - (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.stepNumber) < (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.minNumber))) {
      changeValue(numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.minNumber);
    } else if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.stepNumber && numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.minNumber && parseInt(numberValue) - (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.stepNumber) >= (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.minNumber) || numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.stepNumber && numberValue !== "") {
      changeValue(parseInt(numberValue) - (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.stepNumber));
    } else if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.stepNumber && numberValue == "") {
      changeValue(-(numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.stepNumber));
    } else if (numberValue === "") {
      changeValue(-1);
    } else {
      changeValue(parseInt(numberValue) - 1);
    }
  };

  var incrementNumber = function incrementNumber() {
    var numberValue = value !== null && value !== void 0 ? value : innerValue;

    if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.maxNumber && parseInt(numberValue) > (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.maxNumber)) {
      changeValue(parseInt(numberValue));
    } else if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.minNumber && (parseInt(numberValue) < (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.minNumber) || numberValue === "")) {
      changeValue(numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.minNumber);
    } else if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.maxNumber && (parseInt(numberValue) === (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.maxNumber) || numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.stepNumber && parseInt(numberValue) + (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.stepNumber) > (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.maxNumber))) {
      changeValue(numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.maxNumber);
    } else if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.stepNumber && numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.maxNumber && parseInt(numberValue) + (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.stepNumber) <= (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.maxNumber) || numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.stepNumber && numberValue !== "") {
      changeValue(parseInt(numberValue) + (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.stepNumber));
    } else if (numberInputContext !== null && numberInputContext !== void 0 && numberInputContext.stepNumber && numberValue == "") {
      changeValue(numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.stepNumber);
    } else if (numberValue === "") {
      changeValue(1);
    } else {
      changeValue(parseInt(numberValue) + 1);
    }
  };

  (0, _react.useEffect)(function () {
    if (typeof suggestions === "function") {
      changeIsSearching(true);
      changeIsAutosuggestError(false);
      changeFilteredSuggestions([]);
      var cancelablePromise = makeCancelable(suggestions(value !== null && value !== void 0 ? value : innerValue));
      cancelablePromise.promise.then(function (promiseResponse) {
        changeIsSearching(false);
        changeIsAutosuggestError(false);
        changeFilteredSuggestions(promiseResponse);
      })["catch"](function (err) {
        if (!err.isCanceled) {
          changeIsSearching(false);
          changeIsAutosuggestError(true);
        }
      });
      return function () {
        cancelablePromise.cancel();
      };
    } else if ((suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0) {
      changeFilteredSuggestions(suggestions.filter(function (suggestion) {
        return suggestion.toUpperCase().startsWith((value !== null && value !== void 0 ? value : innerValue).toUpperCase());
      }));
      changeVisualFocusIndex(-1);
    }

    (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.typeNumber) === "number" && setNumberProps(numberInputContext.typeNumber, numberInputContext.minNumber, numberInputContext.maxNumber, numberInputContext.stepNumber);
  }, [value, innerValue, suggestions, numberInputContext]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.textInput
  }, /*#__PURE__*/_react["default"].createElement(TextInputContainer, {
    margin: margin,
    size: size,
    ref: ref
  }, label && /*#__PURE__*/_react["default"].createElement(Label, {
    htmlFor: inputId,
    disabled: disabled,
    backgroundType: backgroundType,
    hasHelperText: helperText ? true : false
  }, label, " ", optional && /*#__PURE__*/_react["default"].createElement(OptionalLabel, null, translatedLabels.formFields.optionalLabel)), helperText && /*#__PURE__*/_react["default"].createElement(HelperText, {
    disabled: disabled,
    backgroundType: backgroundType
  }, helperText), /*#__PURE__*/_react["default"].createElement(InputContainer, {
    error: error ? true : false,
    disabled: disabled,
    backgroundType: backgroundType,
    onClick: handleInputContainerOnClick,
    onMouseDown: handleInputContainerOnMouseDown
  }, prefix && /*#__PURE__*/_react["default"].createElement(Prefix, {
    disabled: disabled,
    backgroundType: backgroundType
  }, prefix), /*#__PURE__*/_react["default"].createElement(AutosuggestWrapper, {
    condition: hasSuggestions(suggestions),
    wrapper: function wrapper(children) {
      return /*#__PURE__*/_react["default"].createElement(Popover.Root, {
        open: isOpen && (filteredSuggestions.length > 0 || isSearching || isAutosuggestError)
      }, /*#__PURE__*/_react["default"].createElement(Popover.Trigger, {
        asChild: true,
        "aria-controls": undefined
      }, children), /*#__PURE__*/_react["default"].createElement(Popover.Content, {
        sideOffset: 5,
        onOpenAutoFocus: function onOpenAutoFocus(event) {
          // Avoid select to lose focus when the list is opened
          event.preventDefault();
        },
        onCloseAutoFocus: function onCloseAutoFocus(event) {
          // Avoid select to lose focus when the list is closed
          event.preventDefault();
        }
      }, /*#__PURE__*/_react["default"].createElement(_Suggestions["default"], {
        id: autosuggestId,
        value: value !== null && value !== void 0 ? value : innerValue,
        suggestions: filteredSuggestions,
        visualFocusIndex: visualFocusIndex,
        highlightedSuggestions: typeof suggestions !== "function",
        searchHasErrors: isAutosuggestError,
        isSearching: isSearching,
        suggestionOnClick: function suggestionOnClick(suggestion) {
          changeValue(suggestion);
          closeSuggestions();
        },
        getTextInputWidth: getTextInputWidth
      })));
    }
  }, /*#__PURE__*/_react["default"].createElement(Input, {
    id: inputId,
    name: name,
    value: value !== null && value !== void 0 ? value : innerValue,
    placeholder: placeholder,
    onBlur: handleInputOnBlur,
    onChange: handleInputOnChange,
    onFocus: openSuggestions,
    onKeyDown: handleInputOnKeyDown,
    onMouseDown: function onMouseDown(event) {
      event.stopPropagation();
    },
    disabled: disabled,
    ref: inputRef,
    backgroundType: backgroundType,
    pattern: pattern,
    minLength: minLength,
    maxLength: maxLength,
    autoComplete: autocomplete === "off" ? "nope" : autocomplete,
    tabIndex: tabIndex,
    type: "text",
    role: hasSuggestions(suggestions) ? "combobox" : undefined,
    "aria-autocomplete": hasSuggestions(suggestions) ? "list" : undefined,
    "aria-controls": hasSuggestions(suggestions) ? autosuggestId : undefined,
    "aria-expanded": hasSuggestions(suggestions) ? isOpen : undefined,
    "aria-haspopup": hasSuggestions(suggestions) ? "listbox" : undefined,
    "aria-activedescendant": hasSuggestions(suggestions) && isOpen && visualFocusIndex !== -1 ? "suggestion-".concat(visualFocusIndex) : undefined,
    "aria-invalid": error ? true : false,
    "aria-errormessage": error ? errorId : undefined,
    "aria-required": optional ? false : true
  })), !disabled && error && /*#__PURE__*/_react["default"].createElement(ErrorIcon, {
    backgroundType: backgroundType,
    "aria-label": "Error"
  }, _Icons["default"].error), !disabled && clearable && (value !== null && value !== void 0 ? value : innerValue).length > 0 && /*#__PURE__*/_react["default"].createElement(Action, {
    onClick: handleClearActionOnClick,
    onMouseDown: function onMouseDown(event) {
      event.stopPropagation();
    },
    backgroundType: backgroundType,
    tabIndex: tabIndex,
    title: translatedLabels.textInput.clearFieldActionTitle,
    "aria-label": translatedLabels.textInput.clearFieldActionTitle,
    type: "button"
  }, _Icons["default"].clear), (numberInputContext === null || numberInputContext === void 0 ? void 0 : numberInputContext.typeNumber) === "number" && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Action, {
    ref: actionRef,
    disabled: disabled,
    onClick: handleDecrementActionOnClick,
    onMouseDown: function onMouseDown(event) {
      event.stopPropagation();
    },
    backgroundType: backgroundType,
    tabIndex: tabIndex,
    title: translatedLabels.numberInput.decrementValueTitle,
    "aria-label": translatedLabels.numberInput.decrementValueTitle,
    type: "button"
  }, _Icons["default"].decrement), /*#__PURE__*/_react["default"].createElement(Action, {
    ref: actionRef,
    disabled: disabled,
    onClick: handleIncrementActionOnClick,
    onMouseDown: function onMouseDown(event) {
      event.stopPropagation();
    },
    backgroundType: backgroundType,
    tabIndex: tabIndex,
    title: translatedLabels.numberInput.incrementValueTitle,
    "aria-label": translatedLabels.numberInput.incrementValueTitle,
    type: "button"
  }, _Icons["default"].increment)), action && /*#__PURE__*/_react["default"].createElement(Action, {
    ref: actionRef,
    disabled: disabled,
    onClick: action.onClick,
    onMouseDown: function onMouseDown(event) {
      event.stopPropagation();
    },
    title: action.title,
    "aria-label": action.title,
    backgroundType: backgroundType,
    tabIndex: tabIndex,
    type: "button"
  }, typeof action.icon === "string" ? /*#__PURE__*/_react["default"].createElement(ActionIcon, {
    src: action.icon
  }) : action.icon), suffix && /*#__PURE__*/_react["default"].createElement(Suffix, {
    disabled: disabled,
    backgroundType: backgroundType
  }, suffix)), !disabled && typeof error === "string" && /*#__PURE__*/_react["default"].createElement(Error, {
    id: errorId,
    backgroundType: backgroundType,
    "aria-live": error ? "assertive" : "off"
  }, error)));
});

var TextInputContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n\n  width: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return calculateWidth(props.margin, props.size);
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
});

var Label = _styledComponents["default"].label(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  ", "\n"])), function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledLabelFontColorOnDark : props.theme.disabledLabelFontColor : props.backgroundType === "dark" ? props.theme.labelFontColorOnDark : props.theme.labelFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.labelFontSize;
}, function (props) {
  return props.theme.labelFontStyle;
}, function (props) {
  return props.theme.labelFontWeight;
}, function (props) {
  return props.theme.labelLineHeight;
}, function (props) {
  return !props.hasHelperText && "margin-bottom: 0.25rem";
});

var OptionalLabel = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: ", ";\n"])), function (props) {
  return props.theme.optionalLabelFontWeight;
});

var HelperText = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  margin-bottom: 0.25rem;\n"])), function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledHelperTextFontColorOnDark : props.theme.disabledHelperTextFontColor : props.backgroundType === "dark" ? props.theme.helperTextFontColorOnDark : props.theme.helperTextFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.helperTextFontSize;
}, function (props) {
  return props.theme.helperTextFontStyle;
}, function (props) {
  return props.theme.helperTextFontWeight;
}, function (props) {
  return props.theme.helperTextLineHeight;
});

var InputContainer = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  position: relative;\n  align-items: center;\n  height: calc(2.5rem - 2px);\n  padding: 0 0.5rem;\n\n  ", "\n  box-shadow: 0 0 0 2px transparent;\n  border-radius: 4px;\n  border: 1px solid\n    ", ";\n  ", "\n  ", ";\n\n  ", ";\n"])), function (props) {
  if (props.disabled) return props.backgroundType === "dark" ? "background-color: ".concat(props.theme.disabledContainerFillColorOnDark, ";") : "background-color: ".concat(props.theme.disabledContainerFillColor, ";");
}, function (props) {
  if (props.disabled) return props.backgroundType === "dark" ? props.theme.disabledBorderColorOnDark : props.theme.disabledBorderColor;else return props.backgroundType === "dark" ? props.theme.enabledBorderColorOnDark : props.theme.enabledBorderColor;
}, function (props) {
  return props.error && !props.disabled && "border-color: transparent;\n     box-shadow: 0 0 0 2px ".concat(props.backgroundType === "dark" ? props.theme.errorBorderColorOnDark : props.theme.errorBorderColor, ";\n  ");
}, function (props) {
  return props.disabled && "cursor: not-allowed;";
}, function (props) {
  return !props.disabled && "\n      &:hover {\n        border-color: ".concat(props.error ? "transparent" : props.backgroundType === "dark" ? props.theme.hoverBorderColorOnDark : props.theme.hoverBorderColor, ";\n        ").concat(props.error ? "box-shadow: 0 0 0 2px ".concat(props.backgroundType === "dark" ? props.theme.hoverErrorBorderColorOnDark : props.theme.hoverErrorBorderColor, ";") : "", "\n      }\n      &:focus-within {\n        border-color: transparent;\n        box-shadow: 0 0 0 2px ").concat(props.backgroundType === "dark" ? props.theme.focusBorderColorOnDark : props.theme.focusBorderColor, ";\n      }\n    ");
});

var Input = _styledComponents["default"].input(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  height: calc(2.5rem - 2px);\n  width: 100%;\n  background: none;\n  border: none;\n  outline: none;\n  padding: 0 0.5rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: 1.5em;\n  ", "\n\n  ::placeholder {\n    color: ", ";\n  }\n"])), function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledValueFontColorOnDark : props.theme.disabledValueFontColor : props.backgroundType === "dark" ? props.theme.valueFontColorOnDark : props.theme.valueFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.valueFontSize;
}, function (props) {
  return props.theme.valueFontStyle;
}, function (props) {
  return props.theme.valueFontWeight;
}, function (props) {
  return props.disabled && "cursor: not-allowed;";
}, function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledPlaceholderFontColorOnDark : props.theme.disabledPlaceholderFontColor : props.backgroundType === "dark" ? props.theme.placeholderFontColorOnDark : props.theme.placeholderFontColor;
});

var ActionIcon = _styledComponents["default"].img(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 16px;\n  height: 16px;\n"])));

var Action = _styledComponents["default"].button(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  height: 24px;\n  width: 24px;\n  font-size: 1rem;\n  font-family: ", ";\n  border: 1px solid transparent;\n  border-radius: 2px;\n  padding: 3px;\n  margin-left: 0.25rem;\n  ", "\n\n  box-shadow: 0 0 0 2px transparent;\n  background-color: ", ";\n\n  color: ", ";\n\n  ", "\n\n  svg {\n    line-height: 18px;\n  }\n"])), function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.disabled ? "cursor: not-allowed;" : "cursor: pointer;";
}, function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledActionBackgroundColorOnDark : props.theme.disabledActionBackgroundColor : props.backgroundType === "dark" ? props.theme.actionBackgroundColorOnDark : props.theme.actionBackgroundColor;
}, function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledActionIconColorOnDark : props.theme.disabledActionIconColor : props.backgroundType === "dark" ? props.theme.actionIconColorOnDark : props.theme.actionIconColor;
}, function (props) {
  return !props.disabled && "\n      &:focus {\n        outline: none;\n        box-shadow: 0 0 0 2px ".concat(props.backgroundType === "dark" ? props.theme.focusActionBorderColorOnDark : props.theme.focusActionBorderColor, ";\n        color: ").concat(props.backgroundType === "dark" ? props.theme.focusActionIconColorOnDark : props.theme.focusActionIconColor, ";\n      }\n      &:focus-visible {\n        outline: none;\n        box-shadow: 0 0 0 2px ").concat(props.backgroundType === "dark" ? props.theme.focusActionBorderColorOnDark : props.theme.focusActionBorderColor, ";\n        color: ").concat(props.backgroundType === "dark" ? props.theme.focusActionIconColorOnDark : props.theme.focusActionIconColor, ";\n      }\n      &:hover {\n        background-color: ").concat(props.backgroundType === "dark" ? props.theme.hoverActionBackgroundColorOnDark : props.theme.hoverActionBackgroundColor, ";\n        color: ").concat(props.backgroundType === "dark" ? props.theme.hoverActionIconColorOnDark : props.theme.hoverActionIconColor, ";\n      }\n      &:active {\n        background-color: ").concat(props.backgroundType === "dark" ? props.theme.activeActionBackgroundColorOnDark : props.theme.activeActionBackgroundColor, ";\n        color: ").concat(props.backgroundType === "dark" ? props.theme.activeActionIconColorOnDark : props.theme.activeActionIconColor, ";\n      }\n    ");
});

var Prefix = _styledComponents["default"].span(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  height: 1.5rem;\n  line-height: 1.5rem;\n  margin-left: 0.25rem;\n  padding: 0 0.5rem 0 0;\n  ", ";\n  font-family: ", ";\n  font-size: 1rem;\n  pointer-events: none;\n"])), function (props) {
  var color = props.disabled ? props.backgroundType === "dark" ? props.theme.disabledPrefixColorOnDark : props.theme.disabledPrefixColor : props.backgroundType === "dark" ? props.theme.prefixColorOnDark : props.theme.prefixColor;
  return "color: ".concat(color, "; border-right: 1px solid ").concat(color, ";");
}, function (props) {
  return props.theme.fontFamily;
});

var Suffix = _styledComponents["default"].span(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  height: 1.5rem;\n  line-height: 1.5rem;\n  margin: 0 0.25rem;\n  padding: 0 0 0 0.5rem;\n  ", ";\n  font-family: ", ";\n  font-size: 1rem;\n  pointer-events: none;\n"])), function (props) {
  var color = props.disabled ? props.backgroundType === "dark" ? props.theme.disabledSuffixColorOnDark : props.theme.disabledSuffixColor : props.backgroundType === "dark" ? props.theme.suffixColorOnDark : props.theme.suffixColor;
  return "color: ".concat(color, "; border-left: 1px solid ").concat(color, ";");
}, function (props) {
  return props.theme.fontFamily;
});

var ErrorIcon = _styledComponents["default"].span(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  padding: 3px;\n  height: 18px;\n  width: 18px;\n  margin-left: 0.25rem;\n  color: ", ";\n\n  svg {\n    line-height: 18px;\n    font-size: 1.25rem;\n  }\n"])), function (props) {
  return props.backgroundType === "dark" ? props.theme.errorIconColorOnDark : props.theme.errorIconColor;
});

var Error = _styledComponents["default"].span(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  min-height: 1.5em;\n  color: ", ";\n  font-family: ", ";\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.5em;\n  margin-top: 0.25rem;\n"])), function (props) {
  return props.backgroundType === "dark" ? props.theme.errorMessageColorOnDark : props.theme.errorMessageColor;
}, function (props) {
  return props.theme.fontFamily;
});

var _default = DxcTextInput;
exports["default"] = _default;